import _ from 'lodash';
import { TableContentDensity, TableTheme, } from '../types';
import { getColumnPropertiesById } from './chart-model-utils';
export var TABLE_CLIENT_STATE_KEYS;
(function (TABLE_CLIENT_STATE_KEYS) {
    TABLE_CLIENT_STATE_KEYS["wrapColumnText"] = "wrapColumnText";
    TABLE_CLIENT_STATE_KEYS["showGridSummary"] = "showGridSummary";
    TABLE_CLIENT_STATE_KEYS["wrapTableHeader"] = "wrapTableHeader";
    TABLE_CLIENT_STATE_KEYS["showTableFooter"] = "showTableFooter";
    TABLE_CLIENT_STATE_KEYS["widthState"] = "widthState";
    TABLE_CLIENT_STATE_KEYS["columnProperties"] = "columnProperties";
    TABLE_CLIENT_STATE_KEYS["orderedColumnIds"] = "ordered_column_ids";
    TABLE_CLIENT_STATE_KEYS["conditionalFormatting"] = "conditionalFormatting";
    TABLE_CLIENT_STATE_KEYS["conditionalFormattingRows"] = "rows";
    TABLE_CLIENT_STATE_KEYS["conditionalFormattingRangeValues"] = "rangeValues";
    TABLE_CLIENT_STATE_KEYS["conditionalFormattingRangeValuesMin"] = "rangeValues.min";
    TABLE_CLIENT_STATE_KEYS["conditionalFormattingRangeValuesMax"] = "rangeValues.max";
    TABLE_CLIENT_STATE_KEYS["conditionalFormattingMin"] = "min";
    TABLE_CLIENT_STATE_KEYS["conditionalFormattingMax"] = "max";
    TABLE_CLIENT_STATE_KEYS["theme"] = "theme";
    TABLE_CLIENT_STATE_KEYS["contentDensity"] = "density";
})(TABLE_CLIENT_STATE_KEYS || (TABLE_CLIENT_STATE_KEYS = {}));
export const isGridSummaryEnabled = (tableClientState = {}) => !!tableClientState.showGridSummary;
export const isTableWrapEnabled = (tableClientState = {}) => { var _a; return (_a = tableClientState.wrapTableHeader) !== null && _a !== void 0 ? _a : true; };
export const getTableTheme = (tableClientState = {}) => tableClientState.theme || TableTheme.Outline;
export const getContentDensity = (tableClientState = {}) => tableClientState.density || TableContentDensity.Regular;
export const isTableFooterEnabled = (tableClientState = {}) => { var _a; return (_a = tableClientState.showTableFooter) !== null && _a !== void 0 ? _a : true; };
export const isTableColumnWrapEnabled = (tableClientState = {}, columnId) => {
    var _a, _b;
    return (_b = (_a = getColumnPropertiesById(tableClientState, columnId)) === null || _a === void 0 ? void 0 : _a.wrapColumnText) !== null && _b !== void 0 ? _b : isTableWrapEnabled(tableClientState);
};
export const updateColumnWrap = (tableClientState = {}, columnId, isWrapEnabled) => {
    const columnPropertyToBeUpdated = getColumnPropertiesById(tableClientState, columnId) || {
        __typename: 'TableVizColumnProperties',
        conditionalFormatting: null,
        wrapColumnText: null,
        isHidden: null,
    };
    const filterColumnPropertyMap = _.filter(tableClientState.columnProperties, colMap => colMap.columnId !== columnId) || [];
    const updatedColumnProperty = {
        ...columnPropertyToBeUpdated,
        wrapColumnText: isWrapEnabled,
    };
    return {
        ...tableClientState,
        columnProperties: [
            ...filterColumnPropertyMap,
            {
                __typename: 'TableColumnPropertyMap',
                columnId,
                columnProperty: updatedColumnProperty,
            },
        ],
    };
};
export const updateColumnsOrderAndVisibility = (tableClientState = {}, orderedColumnIds, hiddenColumnIds) => {
    var _a, _b;
    const hiddenColumnsSet = new Set(hiddenColumnIds);
    const coveredIds = [];
    const columnProperties = (_b = (_a = tableClientState.columnProperties) === null || _a === void 0 ? void 0 : _a.map((value) => {
        var _a;
        coveredIds.push(value.columnId);
        return {
            ...value,
            columnProperty: {
                ...((_a = value === null || value === void 0 ? void 0 : value.columnProperty) !== null && _a !== void 0 ? _a : {}),
                isHidden: hiddenColumnsSet.has(value.columnId),
            },
        };
    })) !== null && _b !== void 0 ? _b : [];
    const updatedVizProp = {
        ...tableClientState,
        orderedColumnIds,
        columnProperties,
    };
    const remainingHiddenColumnIds = _.intersectionWith(_.xor(coveredIds, orderedColumnIds), hiddenColumnIds);
    remainingHiddenColumnIds.forEach(columnId => {
        columnProperties.push({
            __typename: 'TableColumnPropertyMap',
            columnId,
            columnProperty: {
                __typename: 'TableVizColumnProperties',
                conditionalFormatting: null,
                wrapColumnText: null,
                isHidden: true,
            },
        });
    });
    return updatedVizProp;
};
export const updateTableWrap = (tableClientState = {}, isWrapEnabled) => {
    const columnProperties = _.cloneDeep(tableClientState.columnProperties) || [];
    columnProperties.forEach(colMap => {
        const columnProperty = colMap.columnProperty || {
            __typename: 'TableVizColumnProperties',
            conditionalFormatting: null,
            isHidden: null,
        };
        colMap.columnProperty = {
            ...columnProperty,
            wrapColumnText: null,
        };
    });
    return {
        ...tableClientState,
        columnProperties,
        wrapTableHeader: isWrapEnabled,
    };
};
export const updateTableTheme = (tableClientState = {}, theme) => {
    return {
        ...tableClientState,
        theme,
    };
};
export const updateTableFooter = (tableClientState = {}, showTableFooter) => {
    return {
        ...tableClientState,
        showTableFooter,
    };
};
export const updateContentDensity = (tableClientState = {}, contentDensity) => {
    return {
        ...tableClientState,
        density: contentDensity,
    };
};
export const getTableColumnwidth = (tableClientState = {}, columnId) => {
    var _a;
    return (_a = _.find(tableClientState === null || tableClientState === void 0 ? void 0 : tableClientState.widthState, [
        'columnId',
        columnId,
    ])) === null || _a === void 0 ? void 0 : _a.width;
};
export const getMinRangeValue = (metric) => { var _a; return (_a = metric === null || metric === void 0 ? void 0 : metric.rangeValues) === null || _a === void 0 ? void 0 : _a.min; };
export const getMaxRangeValues = (metric) => { var _a; return (_a = metric === null || metric === void 0 ? void 0 : metric.rangeValues) === null || _a === void 0 ? void 0 : _a.max; };
//# sourceMappingURL=table-client-state-utils.js.map